<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('agentList.agentName')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						<el-form-item :label="$t('agentList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item>
						<el-form-item :label="$t('agentList.loginStatus')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('status.enable')" :value="1"></el-option>
								<el-option :label="$t('status.disable')" :value="0"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('agentList.rule')" class="mb-0">
							<el-select v-model="from.rule_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in rule" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
                     <!--   <el-form-item :label="$t('agentList.agentType')" class="mb-0">
							<el-select v-model="from.type" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('agentList.allAgent')" :value="1"></el-option>
								<el-option :label="$t('agentList.oneAgent')" :value="2"></el-option>
							</el-select>
						</el-form-item> -->
						
						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('agentList.add')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" size="mini" @selection-change="handleSelectionChange">
				<el-table-column align="center" fixed prop="id" width="50" label="ID">
				</el-table-column>
				<el-table-column align="center" prop="name" width="100" :label="$t('agentList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="[scope.row.head]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column align="center"  prop="name" :label="$t('agentList.agentName')">
				</el-table-column>
				<el-table-column align="center" prop="username" :label="$t('agentList.loginName')">
				</el-table-column>
				<el-table-column align="center" prop="status" width="100" :label="$t('agentList.loginStatus')">
					<template slot-scope="scope">
						<el-button
							:type="scope.row.status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'status')"
							plain>{{scope.row.status ? $t('agentList.normalLogin') : $t('agentList.forbidLogin')}}
						</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="rule_name" :label="$t('agentList.rule')">
				</el-table-column>
				<!-- <el-table-column align="center" prop="type" :label="$t('agentList.agentType')">
                    <template slot-scope="scope">
						<span v-if="scope.row.type == 1" class="text_chengse">{{$t('agentList.allAgent') }}</span>
						<span v-if="scope.row.type == 2" >{{ $t('agentList.oneAgent') }}</span>
					</template>
				</el-table-column>
                <el-table-column align="center" prop="up_name" :label="$t('agentList.upAgent')">
				</el-table-column> -->
				
				<el-table-column align="center" prop="money" :label="$t('userList.money')">
					<template slot-scope="scope">
						<span class="text_chengse font-weight-bold">$ {{scope.row.money}}</span>
					</template>
				</el-table-column>
                <el-table-column align="center" prop="user_num" :label="$t('agentList.user_num')">
				</el-table-column>
                <el-table-column align="center" prop="tg_id" :label="$t('agentList.TgAccount')">
				</el-table-column>
                <el-table-column align="center" prop="share_code" :label="$t('agentList.shareCode')">
				</el-table-column>
				<el-table-column align="center" prop="create_time" width="180" :label="$t('layout.createTime')">
				</el-table-column>
				<el-table-column align="center" width="140" fixed="right" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							
							<el-button size="mini" plain type="success" v-auth="'editAdmin'" @click="openRebateModel(scope.row)">{{$t('agentList.rebate')}}</el-button>
							<el-button size="mini" plain type="primary" v-auth="'editAdmin'" @click="openModel(scope)">{{$t('layout.operation')}}</el-button>
							<!-- <el-button @click="deleteItem(scope.row)" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button> -->
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
				:layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('agentList.edit') : $t('agentList.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('agentList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'1',cms_type:'4'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
                
				<el-form-item :label="$t('agentList.agentName')" prop="name">
					<el-input v-model="form.name"  clearable size="small" :placeholder="$t('agentList.agentName')"  style="width: 85%;"></el-input>
				</el-form-item>
                <el-form-item :label="$t('agentList.loginName')" prop="username">
					<el-input :disabled="editIndex > -1" v-model="form.username" :maxlength="16" :minlength="6" :placeholder="$t('agentList.loginName')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
				
				<el-form-item  :label="$t('agentList.rule')" prop="rule_group">
					<el-select  v-model="form.rule_group" size="small" filterable :placeholder="$t('system.select')">
						
						<el-option v-for="item in rule" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
                <el-form-item :label="$t('agentList.loginPassword')" prop="password">
					<el-input v-model="form.password" :maxlength="16" :minlength="6" show-password :placeholder="$t('agentList.loginPassword')" size="small" auto-complete="new-password" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('agentList.confirmPassword')" prop="password2">
					<el-input v-model="form.password2" :maxlength="16" :minlength="6" show-password :placeholder="$t('agentList.confirmPassword')" size="small" style="width: 85%;"></el-input>
				</el-form-item>
                <el-form-item :label="$t('agentList.TgAccount')" prop="tg_id">
					<el-input v-model="form.tg_id" :maxlength="16" :minlength="6" :placeholder="$t('agentList.TgAccount')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
				
				<el-form-item :label="$t('agentList.tgQr')" prop="tg_qr">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'1',cms_type:'4'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccessTg"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.tg_qr" :src="form.tg_qr" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
                <el-form-item :label="$t('layout.email')" prop="email">
					<el-input v-model="form.email" :maxlength="16" :minlength="6" :placeholder="$t('layout.email')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
                <el-form-item :label="$t('layout.phone')" prop="phone">
					<el-input v-model="form.phone" :maxlength="16" :minlength="6" :placeholder="$t('layout.phone')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
                <el-form-item :label="$t('agentList.shareCode')" prop="share_code">
					<el-input v-model="form.share_code" :maxlength="16" :minlength="6" :placeholder="$t('agentList.shareCode')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>
				
				<el-form-item :label="$t('agentList.loginStatus')">
					<el-radio-group v-model="form.status" size="small">
						<el-radio :label="1" border>{{$t('agentList.normalLogin')}}</el-radio>
						<el-radio :label="0" border>{{$t('agentList.forbidLogin')}}</el-radio>
					</el-radio-group>
				</el-form-item>
                
                
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" :loading="layout.loading" :disabled="layout.loading" @click="submit">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		
		
		<el-dialog :close-on-click-modal="false"
			:title="$t('agentList.rebate')"
			:visible.sync="rebataModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			
			<div v-loading="rebataLoad">
					<el-table
					  :data="rebateData"
					  border
					  stripe
					  row-key="id"
					  style="width: 100%;"
					>
					  <!-- 展开列：默认不展开 -->
					  <el-table-column type="expand" :label="$t('status.log')" width="50">
					    <template slot-scope="{row}" style="width: 100%;">
							<el-table  :height="400" :data="domain_arr"
							 style="width: 100%;" size="mini" >							<!-- 域名后缀 -->
								<el-table-column align="center"  prop="suffix" :label="$t('domainPrice.domainSuffix')">
									<template slot-scope="scope">
									  <span class="suffix-text">{{ scope.row.suffix }}</span>
									</template>

								</el-table-column>
								
								<!-- 操作类型 -->
								<el-table-column prop="type" :label="$t('domainPrice.operationType')"  align="center">
									<template slot-scope="scope">
									  <el-tag :type="getTypeTagType(scope.row.type)">{{ getTypeText(scope.row.type) }}</el-tag>
									</template>
								  </el-table-column>
								<!-- 年限 -->
								<el-table-column prop="years" :label="$t('domainPrice.years')"  align="center">
									<template slot-scope="scope">
									  {{ scope.row.years }}{{ $t('domain.year') }}
									</template>
								  </el-table-column>


								<!-- 成本价 -->
								<el-table-column prop="cost_price" :label="$t('domainPrice.costPrice')"  align="center">
									<template slot-scope="scope">
									  <span class="price-text">${{ scope.row.cost_price }}</span>
									</template>
								</el-table-column>

								
								<!-- 当前价格 -->
							    <el-table-column prop="price" :label="$t('domainPrice.currentPrice')"  align="center">
									<template slot-scope="scope">
									  <span class="price-text price-current">${{ scope.row.price }}</span>
									</template>
								  </el-table-column>
								  
								<!-- 返佣比例 -->
								
								<el-table-column prop="price" :label="$t('aglevel.rebate')"  align="center">
									<template slot-scope="scope">
									  <span >${{ row.rebate }} %</span>
									</template>
								</el-table-column>
								
								<!-- 代理成本 -->
								<el-table-column prop="price" :label="$t('aglevel.agcost')"  align="center">
									<template slot-scope="scope">
									  <span class="price-text price-current">${{ getAgentPrice(scope.row,row.rebate) }}</span>
									</template>
								</el-table-column>

								
								<!-- 利润 -->
								<!-- <el-table-column :label="$t('domainPrice.profit')"  align="center">
									<template slot-scope="scope">
									  <span :class="getProfitClass(scope.row)">${{ getProfit(scope.row) }}</span>
									</template>
								</el-table-column> -->

								
								
							    
								
								
							</el-table>
						</template>
					  </el-table-column>
										
					 
						<el-table-column align="center" prop="type" :label="$t('aglevel.type')">
							<template slot-scope="scope">
								<span v-if="scope.row.type==1">{{$t('aglevel.domain')}}</span>
							</template>
						</el-table-column>
												
												
												
										
					  <el-table-column :label="$t('aglevel.aglevel')" align="center" min-width="180">
					    <template slot-scope="{ row }">
					      <el-select
					        v-model="row.level"
					        :placeholder="$t('aglevel.aglevel')"
					        size="small"
							@change="changeAgentLeve(row)"
					        style="width: 160px;"
					      >
					        <el-option
					          v-for="opt in row.data"
					          :key="opt.level"
					          :label="opt.name"
					          :value="opt.level"
					        />
					      </el-select>
					    </template>
					  </el-table-column>
										
					  <el-table-column :label="$t('aglevel.rebate')" align="center" min-width="220">
					    <template slot-scope="{ row }">
					      <div class="percent-input">
					        <el-input-number
					          v-model.number="row.rebate"
					          :min="0"
					          :max="100"
					          :step="1"
					          :precision="0"
					          controls-position="right"
					          size="small"
					          style="width: 160px;"
							  @input="limitRebate(row)"
							  @change="limitRebate(row)"
					        />
					        <span class="suffix">%</span>
					      </div>
					    </template>
					  </el-table-column>
										
					  
										
					  <el-table-column :label="$t('layout.operation')" align="center" width="90" >
					    <template slot-scope="{ row }">
					      
					      <el-button :disabled="row.load" :loading="row.load" size="mini" @click="updateRebate(row)" type="primary" >{{$t('cdnd.edit')}}</el-button>
					    </template>
					  </el-table-column>
					</el-table>
			</div>
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				

		       <!-- <el-form-item :label="$t('aglevel.max')" prop="max">
		        	<el-input  v-model="form.max" type="number"  :placeholder="$t('aglevel.max')" clearable size="small" style="width: 85%;" ></el-input>
		        
		        	<div style="font-size: 12px;color: gray;">{{$t('aglevel.maxTis')}}</div>
		        </el-form-item> -->
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="rebataModel = false">{{$t('cdnd.close')}}</el-button>
				<!-- <el-button type="primary" :loading="layout.loading" :disabled="layout.loading" @click="submit">{{$t('system.confirm')}}</el-button> -->
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		name: 'AgentRebatePage',
		data() {
			return {
				domain_arr:[],
				rebateData:[],
				rebataModel:false,
				rebataLoad:false,
				createModel: false,
				editIndex: -1,
				rule:[],
				//搜索數据
				from: {
					name: '',
					username:'',
					status:-1,
					type:-1,
					rule_id:'',
					time:[],
				},
				auth_val: 'Agent',

				preUrl: "user/agentList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "user/delAgent", //删除單条地址
				addUrl: "user/addAgent", //添加/修改地址
				editStatusUrl:"user/editStatusAgent",//修改狀態地址
				
				tableData: [],
				form: {
                    name: "",
						username: '',
						password: '',
						password2: '',
						headUrl: '',
						tgQrUrl: '',
						tg_qr: '',
						icon:'',
						phone:'',
                        email:'',
                        tg_id:'',
                        share_code:'',
						status: 1,
						parent: 0,
						type: 1,
				},
				rules: {
					name: [{
						required: true,
						message: this.$t('agentList.nameRequired'),
						trigger: 'blur',
					}],
					rule_group: [{
						required: true,
						message: this.$t('agentList.selrule'),
						trigger: 'blur',
					}],
					username: [{
						required: true,
						message: this.$t('agentList.usernameRequired'),
						trigger: 'blur',
					}, {
						min: 6,
						max: 16,
						message: this.$t('agentList.usernameLength'),
						trigger: 'blur'
					}],
					
                    password: [{
						validator: this.validateParent, // 使用自定义校验
                        trigger: 'blur'
					}],
				},
				agent_list: [],
				check_img_list:[],
				
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		
		},
		created() {
			this.commonList('agentRule');
		},
		methods: {
			// 获取操作类型文本
			    getTypeText(type) {
			      const typeMap = {
			        'register': this.$t('domainPrice.register'),
			        'renew': this.$t('domainPrice.renew'),
			        'transfer': this.$t('domainPrice.transfer')
			      }
			      return typeMap[type] || type
			    },
			
			    // 获取操作类型标签类型
			    getTypeTagType(type) {
			      const typeMap = {
			        'register': 'success',
			        'renew': 'warning',
			        'transfer': 'info'
			      }
			      return typeMap[type] || ''
			    },
			
			    // 计算利润
			    getProfit(row) {
			      const profit = parseFloat(row.price) - parseFloat(row.cost_price)
			      return profit.toFixed(2)
			    },
				
				// 计算代理价格
				getAgentPrice(row,rebate) {
				  const profit = this.getProfit(row)
				  const price = parseFloat(row.price) - (parseFloat(row.price) * (parseFloat(rebate) / 100))
				  return price.toFixed(2)
				},
				

				
				// 获取利润样式类
				getProfitClass(row) {
				  const profit = parseFloat(row.price) - parseFloat(row.cost_price)
				  if (profit > 0) {
					return 'profit-positive'
				  } else if (profit < 0) {
					return 'profit-negative'
				  } else {
					return 'profit-zero'
				  }
				},


			updateRebate(row){
				row.load = true
				
				this.axios.post('/admin/user/editAgentRebate', {
					id:row.id,
					rebate:row.rebate,
					level:row.level
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					console.log(all)
					this.$message.success(all.msg);
					row.load = false;
				}).catch(err => {
					// 失敗
					row.load = false;
					this.$message.error(all.msg);
				})
			},
			limitRebate(row) {
			       const n = Number(row.rebate)
			        if (!Number.isFinite(n)) row.rebate = 0
			        row.rebate = Math.max(0, Math.min(100, Math.trunc(row.rebate)))
			           
			},
			
			changeAgentLeve(row){
				console.log(row)
				const sel = row.data.find(item=>item.level == row.level)
				row.rebate = sel.rebate
			},
			   
			    
			openRebateModel(item){
				this.rebataModel = true
				
				this.rebataLoad = true;
				this.axios.post('/admin/user/checkAgentRebate', {
					aid: item.id,
					type:'agent',
					uid:0
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.rebateData = list.list
					this.domain_arr = list.domain_arr
					this.rebataLoad = false;
				}).catch(err => {
					// 失敗
					this.rebataLoad = false;
				})
				
			},
            validateParent(rule, value, callback) {
                if (this.form.id > 0) {
                    if (!value) {
                        return callback(new Error(this.$t('agentList.passwordLength'))); // 只有 type == 2 时才校验
                    }
                }
                callback(); // 其他情况不校验
            },
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: this.$t('agentList.differentPasswords'),
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('agentList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						name: "",
						username: '',
						password: '',
						password2: '',
						headUrl: '',
						tgQrUrl: '',
						share_code: '',
						tg_qr: '',
						icon:'',
						phone:'',
                        email:'',
                        tg_id:'',
						status: 1,
						parent: 1,
						rule_group:'',
						type: 1,
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						name: e.row.name,
						username: e.row.username,
						headUrl:  e.row.head,
						tgQrUrl:  e.row.tg_qr,
						share_code:  e.row.share_code,
						tg_qr:  e.row.tg_qr,
						icon: e.row.head,
						phone: e.row.phone,
                        email: e.row.email,
                        tg_id: e.row.tg_id,
						status:  e.row.status,
						parent:  e.row.parent,
						rule_group:  e.row.rule_group,
						type:  e.row.type,
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.rule = list.rule
					console.log(this.rule)
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
            handleAvatarSuccessTg(res, file) {
				this.form.tg_qr = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.tgQrUrl = res.encryption.data.list.url
				}
			},
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					type:-1,
					rule_id:'',
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}

.suffix-text {
  font-weight: bold;
  color: #409EFF;
}

.price-text {
  font-weight: bold;
}

.price-current {
  color: #67C23A;
}

.profit-positive {
  color: #67C23A;
  font-weight: bold;
}

.profit-negative {
  color: #F56C6C;
  font-weight: bold;
}

.profit-zero {
  color: #909399;
  font-weight: bold;
}

.delete-btn {
  color: #F56C6C;
}

.delete-btn:hover {
  color: #F56C6C;
}




</style>
